module.exports = __webpack_public_path__ + "img/logo11.a277b085.jpg";